import { render } from "./Documentation.vue?vue&type=template&id=487a789e&ts=true"
import script from "./Documentation.vue?vue&type=script&lang=ts"
export * from "./Documentation.vue?vue&type=script&lang=ts"

import "./Documentation.vue?vue&type=style&index=0&id=487a789e&lang=scss"

import exportComponent from "/home/runner/work/platform/platform/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__